export const getBreakdown = (price: number, percentages: { contribution: number }[]) => {
  const totalContributions = percentages.reduce((acc, { contribution }) => acc + contribution, 0);
  const base = price - totalContributions;
  return base;
};
